import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "ma-2" }
const _hoisted_2 = { class: "text-left" }
const _hoisted_3 = { class: "text-left" }
const _hoisted_4 = { class: "text-left" }
const _hoisted_5 = { class: "text-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createVNode(_component_v_breadcrumbs, {
        class: "px-0",
        items: [
          { title: 'Child Development', href: '/child-development', color: 'primary' },
          { title: `${_ctx.className} (${_ctx.year} ${_ctx.$t('childDevelopment.fiscalYear')})` },
        ]
      }, null, 8, ["items"])
    ]),
    _createVNode(_component_page_title, {
      value: `${_ctx.$t('childDevelopment.title')} - ${_ctx.className} (${_ctx.year} ${_ctx.$t('childDevelopment.fiscalYear')})`
    }, null, 8, ["value"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_table, null, {
        default: _withCtx(() => [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_2, _toDisplayString(_ctx.$t('childDevelopment.childName')), 1),
              _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.$t('childDevelopment.age')), 1),
              _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t('childDevelopment.developmentRecord')), 1),
              _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t('childDevelopment.progressRecord.title')), 1)
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.children, (c, i) => {
              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                _createElementVNode("td", null, _toDisplayString(`${c.lastName} ${c.firstName}`), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.getAgeBasedonBirthdate(c.dateOfBirth)), 1),
                _createElementVNode("td", null, [
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "outlined",
                    to: `/child-development/child/${_ctx.year}/${c.childId}`
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('childDevelopment.edit')), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "outlined",
                    to: `/child-development/progress/${_ctx.year}/${c.childId}`
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('childDevelopment.edit')), 1)
                    ]),
                    _: 1
                  }, 8, ["to"])
                ])
              ]))
            }), 128))
          ])
        ]),
        _: 1
      })
    ])
  ]))
}